import React, { createContext, useState, useReducer} from "react";
import {Data} from '../components/Data'
import data from '../components/Brands/DataBrand'
import {reducer} from './Reducer'


export const AuthContext = createContext();

const AuthContextProvider = ({ children }) => {
  
  const [count,setCount]=useState([])
  const [datas, setDatas] = useState(data)
    const [item, setItem] = useState(Data)
    const [carts,setCarts]=useState([])
    const [state, dispatch] = useReducer(reducer,{
      products:data,
      product2:Data,
      cart:[]
    })

  return (
    <AuthContext.Provider value={{
      item, setItem,
      datas, setDatas,
      state, dispatch,
      carts,setCarts,
      count,setCount,
      }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;